import { Address } from '@kanda-libs/ks-frontend-services';

export const getTimeAtAddress = (
  address: Partial<Address> | undefined,
): number | undefined => address?.months_at_address;
